import React from "react";
import { Container } from "./Styled";
import { List } from "antd";

type ItemProps = {
  onSelect: () => void;
  isSelected: boolean;
  children?: React.ReactNode;
};

const Item: React.FunctionComponent<ItemProps> = ({ onSelect, isSelected, children }) => {
  return (
    <Container isSelected={isSelected}>
      <List.Item onClick={onSelect}>
        {children}
      </List.Item>
    </Container>
  );
};

export default Item;
